import { render } from "./Navbar.vue?vue&type=template&id=63a35dc9&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=63a35dc9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63a35dc9"

export default script